import { combineReducers } from 'redux';

import list from './sftp/sftp-list';
import selectedEntry from './sftp/selected-sftp-entry';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';

const sftp = combineReducers({
  list,
  selectedEntry,
  isLoading: loadingStatusAccordingToReducer('sftpListLoadingStatus'),
});

export default sftp;



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/reducers/sftp.reducer.js